(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hcw-trade-portal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = (root) => {
    root.querySelectorAll('[data-hcw-portal]').forEach((portal) => {
      if (portal.dataset.mounted) return;
      const panels = Array.from(portal.querySelectorAll('[data-portal-panel]'));
      if (!panels.length) return;
      portal.dataset.mounted = 'true';
      portal.classList.add('is-enhanced');
      const activate = (key) => {
        if (!panels.some((panel) => panel.dataset.portalPanel === key)) return;
        panels.forEach((panel) => { panel.hidden = panel.dataset.portalPanel !== key; });
        portal.querySelectorAll('.hcw-portal__nav [data-portal-tab]').forEach((link) => {
          if (link.dataset.portalTab === key) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
      };
      const fromHash = () => {
        const panel = panels.find((item) => '#' + item.id === window.location.hash);
        activate(panel ? panel.dataset.portalPanel : 'overview');
      };
      portal.querySelectorAll('[data-portal-tab]').forEach((link) => {
        link.addEventListener('click', () => activate(link.dataset.portalTab));
      });
      window.addEventListener('hashchange', fromHash);
      fromHash();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target.parentNode || document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hcw-vibe"] && !Shopify.designMode) return;
  try {
    
(() => {
const mount = (section) => {
const apply = () => {
const host = section.querySelector('shopify-forms-embed');
const root = host && host.shadowRoot;
if (!root) return;
if (!root.getElementById('hcw-trade-style')) {
const style = document.createElement('style'); style.id='hcw-trade-style';
style.textContent = ":host{--inline-container-max-width:640px!important;--container-text-alignment:left!important;--forms-padding-top:0px!important;--forms-padding-bottom:0px!important;--form-field-border-radius:0px!important;--button-border-radius:0px!important;--form-field-border:0 0 0 1px #cbd3ce!important;--forms-body-font:normal 400 12px Arial,sans-serif!important;--button-background-color:#3a2d27!important;--button-text-color:#ffffff!important;--form-field-padding:12px!important} [data-sizing='form-wrapper']{max-width:none!important;width:100%!important} section:has(>form){width:100%} section:has(form) [class*='_formHeader_']{display:none!important} form[data-hcw-layout]{display:grid!important;grid-template-columns:repeat(6,minmax(0,1fr));gap:12px!important;reading-flow:grid-rows} form[data-hcw-layout]>div{min-width:0} form[data-hcw-layout] input:not([type=radio]):not([type=checkbox]):not([type=file]){min-height:42px!important;border-radius:0!important;font-size:12px!important;background:white!important} form[data-hcw-layout] label{font-family:Arial,sans-serif;font-size:12px} form[data-hcw-layout] input[aria-required=true]+label::after{content:' *';color:#a33c32} form[data-hcw-layout] h2.hcw-form-heading{grid-column:1/-1;font-family:var(--hcw-heading-font,Georgia,serif);font-size:28px;line-height:1.2;font-weight:400;margin:22px 0 4px;color:#202020} form[data-hcw-layout] h2.hcw-form-heading:first-child{margin-top:0} form[data-hcw-layout] h3.hcw-form-heading{grid-column:1/-1;font:bold 12px/1.5 Arial,sans-serif;margin:16px 0 0} form[data-hcw-layout] .hcw-doc-help{grid-column:1/-1;font:12px/1.5 Arial,sans-serif;margin:0} form[data-hcw-layout]>button[type=submit]{grid-column:1/-1;justify-self:center!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;align-self:center!important;box-sizing:border-box!important;width:auto!important;min-width:min(240px,100%)!important;max-width:100%!important;height:48px!important;min-height:48px!important;padding:0 28px!important;margin:20px auto 0!important;line-height:1!important;text-align:center!important;border-radius:0!important;background:#3a2d27!important;color:#fff!important;text-transform:uppercase;letter-spacing:.12em;font-size:12px!important} form[data-hcw-layout] [role=radiogroup]{display:flex!important;flex-wrap:wrap;gap:18px} form[data-hcw-layout] input[type=radio]{accent-color:#31564c} [class*='_formDisclaimer_']{font:11px/1.5 Arial,sans-serif;text-align:left!important;margin-top:15px!important}@media(max-width:540px){form[data-hcw-layout]{grid-template-columns:minmax(0,1fr)!important}form[data-hcw-layout]>div{grid-column:1/-1!important}form[data-hcw-layout]>.hcw-third{grid-column:1/-1!important}form[data-hcw-layout] h2.hcw-form-heading{font-size:26px}}";
root.append(style); host.style.setProperty('--hcw-heading-font',getComputedStyle(section).getPropertyValue('--font-heading-family') || 'Georgia,serif');
}
const form=root.querySelector('form[data-testid="form"]');
if (form) { const loading=section.querySelector('[data-hcw-form-loading]'); if(loading) loading.hidden=true; }
if(!form || form.dataset.hcwLayout) return;
const entries=[];
const addHeading=(key,order,tag='h2')=>{const el=document.createElement(tag);el.className='hcw-form-heading';el.textContent=section.dataset[key];entries.push({node:el,order,span:6});};
const field=(id,order,span=3)=>{const input=root.getElementById(id);if(!input)return;let node=input;while(node.parentElement && node.parentElement!==form)node=node.parentElement;if(node.parentElement===form) entries.push({node,order,span});};
addHeading('company',1);field('custom#company_type-Interior Designer',2,6);field('custom#company_name',3);field('custom#company_website_',4);field('custom#asid_number',5);
addHeading('billing',10,'h3');field('custom#business_address',11,6);field('custom#billing_address_line_2',12,6);field('custom#billing_city',13,2);field('custom#billing_state_province',14,2);field('custom#billing_zip_postal_code',15,2);field('custom#billing_country',16);field('custom#billing_phone',17);
addHeading('shipping',20,'h3');field('custom#shipping_address_line_1',21,6);field('custom#shipping_address_line_2',22,6);field('custom#shipping_city',23,2);field('custom#shipping_state_province',24,2);field('custom#shipping_zip_postal_code',25,2);field('custom#shipping_country',26);field('custom#shipping_phone',27);
addHeading('contact',30);field('first_name',31);field('last_name',32);field('email',33);field('phone_number',34);
addHeading('documents',40);const help=document.createElement('p');help.className='hcw-doc-help';help.textContent=section.dataset.documentsHelp;entries.push({node:help,order:41,span:6});field('custom#supporting_documents_optional-field',42,6);
addHeading('signature',50);field('custom#signatory_first_name',51);field('custom#signatory_last_name',52);field('custom#professional_title',53,6);field('custom#typed_signature',54);field('custom#todays_date',55);addHeading('referral',60);field('custom#how_did_you_hear_about_us-Search Engine',61,6);field('custom#other_referral_details',62,6);
const button=form.querySelector('button[type=submit]');if(button)entries.push({node:button,order:90,span:6});
for(const child of Array.from(form.children)){if(!entries.some(e=>e.node===child))entries.push({node:child,order:85,span:6});}
form.dataset.hcwLayout='true';
entries.sort((a,b)=>a.order-b.order).forEach(({node,span})=>{node.style.gridColumn=span===6?'1 / -1':'span '+span;if(span===2)node.classList.add('hcw-third');form.append(node);});
};
let attempts=0;const timer=setInterval(()=>{apply();if(++attempts>=480)clearInterval(timer);},250);
apply();section.addEventListener('shopify:section:unload',()=>clearInterval(timer),{once:true});
};
document.querySelectorAll('[data-hcw-trade-layout]').forEach(mount);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hcw-trade-layout]').forEach(mount));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
